import { render } from "./Configurazione.vue?vue&type=template&id=054c8766"
import script from "./Configurazione.vue?vue&type=script&lang=js"
export * from "./Configurazione.vue?vue&type=script&lang=js"
script.render = render

export default script